import { Box } from "@mui/material";
import AppNav from "../components/AppNav";
import { Outlet } from "react-router-dom";

export default function DashboardLayout() {
  return (
    <Box
      className="app-shell"
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        minHeight: 0,
        minWidth: 0,
        overflow: "hidden",
        "@supports (height: 100dvh)": {
          height: "100dvh",
        },
      }}
    >
      <AppNav />

      <Box
        component="main"
        className="app-main"
        sx={(theme) => ({
          flexGrow: 1,
          minHeight: 0,
          minWidth: 0,
          overflowY: "auto",
          overflowX: "hidden",
          bgcolor: theme.palette.background.default,
          scrollBehavior: "smooth",
          position: "relative",

          "&::-webkit-scrollbar": {
            width: "10px",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "rgba(100, 100, 100, 1)",
            borderRadius: "8px",
          },
          "&::-webkit-scrollbar-thumb:hover": {
            backgroundColor: "rgba(125, 125, 125, 1)",
          },
          "&::-webkit-scrollbar-track": {
            backgroundColor: "rgba(50, 50, 50, 1)",
            borderRadius: "8px",
          },
        })}
      >
        <Box
          sx={{
            p: "var(--app-page-padding, 24px)",
            flex: 1,
            minHeight: 0,
            minWidth: 0,
            display: "flex",
            flexDirection: "column",
            boxSizing: "border-box",
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
}
